import type { TFunction } from 'i18next';
import { SIGNUP_LEGAL_DOCUMENT_PATHS } from '../legal/legal-document-paths';
import { TELEHEALTH_CONSENT_PDF_PATH } from '../services/legal-documents';

/**
 * The two consents a new account needs, as production words them on both
 * its account screen and its employer SSO screen: the terms, privacy and
 * TCPA documents, and telehealth with the data disclosure.
 */
export function termsSegments(t: TFunction) {
  return [
    { text: t('account.consentTerms.intro') },
    {
      text: t('account.consentTerms.termsOfUse'),
      href: SIGNUP_LEGAL_DOCUMENT_PATHS.termsOfUse,
    },
    { text: t('account.consentTerms.comma') },
    {
      text: t('account.consentTerms.privacyPolicy'),
      href: SIGNUP_LEGAL_DOCUMENT_PATHS.privacyPolicy,
    },
    { text: t('account.consentTerms.comma') },
    {
      text: t('account.consentTerms.noticeOfPrivacyPractices'),
      href: SIGNUP_LEGAL_DOCUMENT_PATHS.noticeOfPrivacyPractices,
    },
    { text: t('account.consentTerms.and') },
    {
      text: t('account.consentTerms.tcpaAuthorization'),
      href: SIGNUP_LEGAL_DOCUMENT_PATHS.tcpaAuthorization,
    },
    { text: t('account.consentTerms.outro') },
  ];
}

export function telehealthSegments(t: TFunction, disclosureLink: string) {
  return [
    { text: t('account.consentTelehealth.intro') },
    {
      text: t('account.consentTelehealth.telehealth'),
      href: TELEHEALTH_CONSENT_PDF_PATH,
    },
    { text: t('account.consentTelehealth.and') },
    { text: t('account.consentTelehealth.disclosure'), href: disclosureLink },
  ];
}
